export const emptyCharacter = '‎'
